module.exports = __webpack_public_path__ + "media/images/icons/share_white-d60edac29bcdb657a0d0361e6ccf8ad3.svg";